




export default {
	name: 'DateTimeDisplay',

	setup() {},

	props: {
		date: {
			required: true,
			type: String,
		},
		time: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	computed: {
		formattedDate() {
			if (this.time) {
				return this.$dayjs(this.date).format('DD/MM/YYYY HH:mm');
			}

			return new Date(this.date).toLocaleDateString();
		},
	},

	created() {},

	methods: {},
};
